import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AllShiftMaster,
  AddShiftName,
  UpdateShiftDetails,
  getShiftById,
} from "../../Apis/shiftMasterApi";
import TableComponent from "../../Common/TableComponent/tableComponent";
import Loader from "../../Common/Loader/loader";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";
import "./shiftMaster.css";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import TableSkeleton from "../AllotedMaster/TableSkeleton";
const ShiftMaster = ({ t }) => {
  const navigate = useNavigate();
  const headers = [
    "shift",
    "startTime",
    "endTime",
    "shiftCode",
    "status",
    "actions",
  ];
  const [lgShow, setLgShow] = useState(false);
  const [shiftData, setShiftData] = useState([]);
  const [editShiftData, setEditShiftData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [shiftName, setShiftName] = useState([]);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [sortedData, setSortedData] = useState([]); // New state to store sorted data
  const [excelData, setExcelData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [sortConfig, setSortConfig] = useState(null);
  const [formInput, setFormInput] = useState({
    shiftName: "",
    startTime: "",
    endTime: "",
    shiftCode: "",
    isActive: true,
    // company_id: "",
  });

  const handleClose = () => {
    setFormInput({
      shiftName: "",
      startTime: "",
      endTime: "",
      shiftCode: "",

      // company_id: "",
    });
    setLgShow(false);
    setFormSubmitted(false);
  };

  const handleShow = () => {
    setLgShow(true);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      shiftName: "",
      startTime: "",
      endTime: "",
      shiftCode: "",
      isActive: true,

      // company_id: "",
    });
    setEditShiftData(null);
  };

  const formatTimeTo24Hour = (time) => {
    const [hours, minutes] = time.split(":");
    return `${hours}:${minutes || "00"}`;
  };

  const handleEditShift = (selectedShift) => {
    setEditShiftData(selectedShift);
    setIsLoading(true);
    setTimeout(() => setIsLoading(false), 1000);
    setFormInput({
      shiftName: selectedShift.shiftName,
      startTime: selectedShift.startTime,
      endTime: selectedShift.endTime,
      company_id: selectedShift.company_id,
      shiftCode: selectedShift.shiftCode,
      isActive: selectedShift.isActive,
      shiftId: selectedShift.shiftId,
    });
    setLgShow(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormInput((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    // Ensure that the time is in the format "HH:MM:SS"
    if (name === "startTime" || name === "endTime") {
      // Append ":00:00" to the provided time if it's in "HH:MM" format
      const formattedTime = value ? (value.includes(":")
        ? `${value}:00`
        : `${value}:00:00`) : '';

      // console.log(formattedTime,'time value');
      setFormInput((prevData) => ({ ...prevData, [name]: formattedTime }));
    } else if (name === "shiftName") {
      // Remove any numbers from the input
      const sanitizedValue = value.replace(/[^A-Za-z\s]/g, "");
      setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));
    } else if (name === "shiftCode") {
      // Remove any non-alphanumeric characters and capitalize the string
      const sanitizedValue = value.toUpperCase().replace(/[^A-Z0-9-]/g, "");
      setFormInput((prevData) => ({ ...prevData, [name]: sanitizedValue }));
    } else {
      setFormInput((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleCreateShift = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    try {
      setIsLoading(true);

      if (editShiftData) {
        // Perform validation for required fields only when adding new data
        if (
          !formInput.shiftName ||
          // !formInput.shiftCode ||
          !formInput.startTime ||
          !formInput.endTime
        ) {
          // toast.error("Please fill in all required fields.", {
          //   position: "top-right",
          //   autoClose: 5000,
          //   hideProgressBar: false,
          // });
          return;
        }

        // if (formInput.startTime === formInput.endTime) {
        //   toast.error("Start Time and End Time cannot be the same.", {
        //     position: "top-right",
        //     autoClose: 5000,
        //     hideProgressBar: false,
        //   });
        //   return;
        // }
        const isDuplicateCode = shiftData.some(
          (shift) =>
            shift.shiftCode === formInput.shiftCode &&
            shift.id !== editShiftData?.id // Exclude the current edited shift if any
        );

        // if (isDuplicateCode) {
        //   // If duplicate code found, show error toast and return
        //   toast.error(
        //     "Shift Code already exists. Please choose a different one.",
        //     {
        //       position: "top-right",
        //       autoClose: 5000,
        //       hideProgressBar: false,
        //     }
        //   );
        //   return;
        // }
      }
      if (editShiftData) {
        // Update existing shift
        const updatedShiftData = {
          ...formInput,
          shiftId: editShiftData.shiftId,
        }; // Include the ID
        const response = await UpdateShiftDetails(updatedShiftData);
        // Update the state with the modified data
        const updatedShifts = shiftData.map((shift) =>
          shift.shiftId === response.id ? response : shift
        );
        setShiftData(updatedShifts);
        toast.success("Shift Details updated successfully");
      } else {
        // Add new shift
        const response = await AddShiftName({
          ...formInput,
          isActive: formInput.isActive,
        });
        setShiftData([...shiftData, response]);
        toast.success("Shift Details added successfully");
        // Close the modal after successful addition
      }
      fetchShiftDetails();
      handleClose();
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 404) {
          // Handle 400 status code errors with validation errors
          const validationErrors = data;
          // for (const field in validationErrors) {
          toast.error(validationErrors, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
          // }
        } else if (status === 409) {
          // Handle 409 status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        } else if (status === 400) {
          // Handle other status code errors
          const errorMessage = data;
          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
          });
        }
      }
    } finally {
      setIsLoading(false);
    }
  };



  const handleViewShiftData = async (id) => {
    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setIsLoading(true);
      const response = await getShiftById(id);
      const shiftDetails = response.data;
      navigate("/view-shift-details", { state: { shiftDetails } });
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchShiftDetails = async () => {
    try {
      setIsLoading(true);
      const response = await AllShiftMaster();
      setShiftData(response);
      setOriginalData(response);
      
      const shiftData = response.map((station) => {
        return {
          ...station,
          shift: station.shiftName, // Assuming the API response has a key named shiftName for shift names
          status: station.isActive ? "Active" : "InActive",
        };
      });

      // Sort the data based on the isActive field
      const sortedshiftData = shiftData.sort((a, b) => {
        if (a.isActive === b.isActive) {
          return 0;
        }
        return a.isActive ? -1 : 1;
      });

      setShiftName(sortedshiftData);
    } catch (error) {
      console.error("Error fetching shift data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchShiftDetails();
  }, []);

  // const downloadAsExcel = () => {
  //   // Add serial number to each item in the collection details
  //   const dataWithSerialNumber = shiftName.map((item, index) => ({
  //     ...item,
  //     "s.no": index + 1,
  //   }));

  //   // Filter out only the data corresponding to the headers displayed in the table component
  //   const filteredData = dataWithSerialNumber.map((item) => ({
  //     "s.no": item["s.no"],
  //     shift: item.shift,
  //     startTime: item.startTime,
  //     endTime: item.endTime,
  //     shiftCode: item.shiftCode,
  //     status: item.status,
  //   }));

  //   const ws = XLSX.utils.json_to_sheet(filteredData);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Shift");
  //   const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  //   const data = new Blob([excelBuffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  //   });
  //   const downloadLink = document.createElement("a");
  //   downloadLink.href = URL.createObjectURL(data);
  //   downloadLink.download = "Shift.xlsx";
  //   downloadLink.click();
  // };

  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const generationTime = ` ${new Date()
    .toLocaleString("en-GB", options)
    .replace(/\//g, "/")}`;

  const convertTo12HrFormat = (time) => {
    const [hours, minutes] = time.split(":").map(Number);  // Split and convert to numbers
    const suffix = hours >= 12 ? "PM" : "AM";  // Determine AM/PM suffix
    const hour12 = hours % 12 || 12;  // 0 becomes 12, other hours are modulo 12
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes; // Pad single digit minutes
    return `${hour12}:${formattedMinutes} ${suffix}`;
  };

  const downloadAsExcel = async (data) => {
    // Create a new workbook and add a worksheet
    const dataToUse = sortedData.length > 0 ? sortedData : originalData;
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `Shift Report Generated on: ${generationTime},${formattedTime}`;

    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Shifts");

    // Define styles
    const boldFont = { bold: true };

    // Add the downloadDateTime to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 6); // Merge cells for downloadDateTime from column 2 to 4
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells (B1, C1, D1)
    for (let col = 2; col <= 6; col++) {
      worksheet.getCell(1, col).font = boldFont;
      worksheet.getCell(1, col).alignment = { horizontal: "center" };
    }

    // Add "Zone Details" to the correct row and columns, and ensure formatting
    worksheet.addRow(["", "", "Shift Details", ""]);
    worksheet.mergeCells(2, 2, 2, 6);
    worksheet.getCell(2, 2).value = "Shift Details";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    // Apply styles to the merged cells (B2, C2, D2)
    for (let col = 2; col <= 6; col++) {
      worksheet.getCell(2, col).font = boldFont;
      worksheet.getCell(2, col).alignment = { horizontal: "center" };
    }

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Shift",
      "Start Time",
      "End Time",
      "Shift Code",
      "Status",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left", color: "#fff" };
      if (colNumber >= 1 && colNumber <= 6) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" }, // White text color
        };
      }
    });

    // Add data rows, converting times to 12-hour format
    shiftName.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.shiftName,
          convertTo12HrFormat(item.startTime),  // Convert startTime to 12-hour format
          convertTo12HrFormat(item.endTime),    // Convert endTime to 12-hour format
          item.shiftCode,
          item.isActive ? 'Active' : 'InActive',
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 6) {
            cell.alignment = { horizontal: "left" };
          } else {
            cell.alignment = { horizontal: "center" };
          }
        });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 15 },
      { width: 15 },
      { width: 15 },
      { width: 40 },
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ShiftDetails.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  let storedPermissions = localStorage.getItem('permissionId')
  const permissionValues1 = JSON.parse(localStorage.getItem('rolePermissions')) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  // Use this page's own permissionId so the Add/Update buttons don't depend on
  // the shared localStorage "permissionId" (which caused them to sometimes hide).
  storedPermissions = 9;

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(mapping => mapping.permissionId === storedPermissions);

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(`canWrite value for permission ID ${storedPermissions}:`, canWriteValue);
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }


  const handleSort = (sortConfig) => {
    // Assuming you have a method to sort data based on sortConfig
    const sorted = [...shiftName].sort((a, b) => {
      if (sortConfig.order === 'asc') {
        return a[sortConfig.column] > b[sortConfig.column] ? 1 : -1;
      } else {
        return a[sortConfig.column] < b[sortConfig.column] ? 1 : -1;
      }
    });

    setSortedData(sorted); // Update the sorted data
  };
  const handleSortAndExport = async () => {
    if (sortConfig) {
      handleSort(sortConfig); // Apply sorting
      await new Promise((resolve) => setTimeout(resolve, 100)); // Wait for state update
    }
    const dataToExport = (sortConfig ? sortedData : originalData).slice().sort((a, b) => {
      if (a.isActive && !b.isActive) return -1;
      if (!a.isActive && b.isActive) return 1;
      return 0; // Use sorted or original data
      // Export the data
    });
    downloadAsExcel(dataToExport);
  }
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              <div className="flex_end_middle mb-3">
                {canWriteValue === true ?
                  <button className="button-container" onClick={handleShow}>
                    <i className="fa-solid fa-plus me-1 icon-container"></i>
                    {t("addShift")}
                  </button>
                  : ''}
                <button className="btn btn-excel"
                  onClick={handleSortAndExport}>
                  <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                </button>
              </div>
            </div>
            <div className="top-header">
              <span>{t("shift")}</span>
            </div>
            <div className="card">
              <div className="card-body">
                {isLoading?<TableSkeleton />: <TableComponent
                  DataFetchURL={shiftName}
                  headers={headers}
                  filterFunction={(data) =>
                    data.filter(
                      (item) => item.status === 1 || item.status === 2
                    )
                  }
                  editData={handleEditShift} // Pass the callback function
                  editShiftData={editShiftData}
                  viewData={(id) => handleViewShiftData(id)}
                  onSort={handleSort}
                  skipGetCircle={true}
                />}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        show={lgShow}
        onHide={() => handleClose()}
        aria-labelledby="example-modal-sizes-title-lg"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="example-modal-sizes-title-lg">
            {editShiftData ? t("editShift") : t("addShift")}
          </Modal.Title>
          <i
            class="fa-solid fa-xmark close-container"
            onClick={handleClose}
          ></i>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <form onSubmit={handleCreateShift}>
            <div className="row">
              {/* <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Shift Code <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Shift Code"
                    name="shiftCode"
                    className={`form-control ${formInput.shiftCode || !formSubmitted ? "" : "input-error"
                      }`}
                    onChange={handleInputChange}
                    value={formInput.shiftCode}
                    maxLength={8}
                    disabled={!canWriteValue}
                  />
                  {!formInput.shiftCode && formSubmitted && (
                    <div className="required-message">
                      Shift Code is Required
                    </div>
                  )}
                </div>
              </div> */}
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Shift <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Shift"
                    name="shiftName"
                    className={`form-control ${formInput.shiftName || !formSubmitted ? "" : "input-error"
                      }`}
                    maxLength={50}
                    onChange={handleInputChange}
                    value={formInput.shiftName}
                    disabled={!canWriteValue}
                  />
                  {!formInput.shiftName && formSubmitted && (
                    <div className="required-message">
                      Shift is Required
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    Start Time <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="time"
                    name="startTime"
                    className={`form-control ${formInput.startTime || !formSubmitted ? "" : "input-error"
                      }`}
                    onChange={handleInputChange}
                    value={formatTimeTo24Hour(formInput.startTime || "")}
                    disabled={!canWriteValue}
                  />
                  {!formInput.startTime && formSubmitted && (
                    <div className="required-message">
                      Start Time is Required
                    </div>
                  )}
                </div>
              </div>
              <div className="col-md-4 mb-3">
                <div className="form-group">
                  <label className="form-label">
                    End Time <span style={{ color: "#EC1117" }}> *</span>
                  </label>
                  <input
                    type="time"
                    name="endTime"
                    className={`form-control ${formInput.endTime || !formSubmitted ? "" : "input-error"
                      }`}
                    onChange={handleInputChange}
                    value={formatTimeTo24Hour(formInput.endTime || "")}
                    disabled={!canWriteValue}
                  />
                  {!formInput.endTime && formSubmitted && (
                    <div className="required-message">End Time is Required.</div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-md-4" style={{ marginTop: "5px" }}>
              <label className="form-label">
                {t("status")}
                <span style={{ color: "#EC1117" }}> *</span>
              </label>
              <div className="form-group" style={{ display: "flex" }}>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="activeRadio"
                    checked={formInput.isActive} // Check if isActive is true
                    onChange={() =>
                      handleInputChange({
                        target: { name: "isActive", value: true }, // Set value to true
                      })
                    }
                  />

                  <label className="form-check-label" htmlFor="activeRadio">
                    Active
                  </label>
                </div>
                <div className="form-check" style={{ marginLeft: "40px" }}>
                  <input
                    type="radio"
                    className="form-check-input"
                    name="isActive"
                    id="inactiveRadio"
                    checked={formInput.isActive === false}
                    onChange={() =>
                      handleInputChange({
                        target: { name: "isActive", value: false }, // Set value to false
                      })
                    }
                  />

                  <label className="form-check-label" htmlFor="inactiveRadio">
                    InActive
                  </label>
                </div>
              </div>
              {/* {!formInput.isActive && formSubmitted && (
                    <div className="required-message">Required.</div>
                  )} */}
            </div>
            <div className="modal-footer d-flex justify-content-center">
              {canWriteValue === true ?
                <button type="submit" className="deployment-button">
                  <i class="fa-solid fa-check done-container"></i>
                  {editShiftData ? t("Update") : t("Save")}
                </button>
                : ''}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default withTranslation()(ShiftMaster);
